import { render } from "./ChatLauncher.vue?vue&type=template&id=21abed37"
import script from "./ChatLauncher.vue?vue&type=script&lang=js"
export * from "./ChatLauncher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__